import type { AppModule } from '@ohmybible/core';

import router from '@/core/router';

export const registerModules = (modules: Record<string, AppModule>): void => {
  for (const module of Object.values(modules)) {
    for (const route of Object.values(module.routes ?? {})) {
      router.addRoute(route);
    }
  }
};
